import React from 'react'
import { Col, Container, Row } from 'reactstrap'

const Rating = () => {
  return (
    <section>
        <Container className='container-fluid'>
          <Row>
            <Col md={12} className='text-center'>
              <div className='tamp-d-flex'>
                <div>
                  <p className='coming-title rating-title'>If you love this template please rate us</p>
                  <div className='rating-star'>
                    <img src='assets/images/star.png' alt='star' />
                    <img src='assets/images/star.png' alt='star' />
                    <img src='assets/images/star.png' alt='star' />
                    <img src='assets/images/star.png' alt='star' />
                    <img src='assets/images/star.png' alt='star' />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
  )
}

export default Rating